import {
  useEffect,
  useState,
} from 'react'
import {
  Navigate,
  useParams,
} from 'react-router-dom'
import axios from "axios"
import DatePicker from "react-datepicker"
import "react-tooltip/dist/react-tooltip.css"
import Swal from 'sweetalert2'
import { NumericFormat } from 'react-number-format'
import { useTranslation } from 'react-i18next'
import {
  ROUTE_PATHS,
} from '../../../library/helper'

import Attachment from '../../../components/Attachment'
import NotFound from '../../../components/NotFound'
import LoadingCard from '../../../components/LoadingCard'
import { useSelector } from 'react-redux'

const AttachmentChildren = ({
  isLoading,
  attachmentData,
  setSelectedFile,
  onAttachFile,
  selectedFile,
  onChangeFile,
}) => {
  const { t } = useTranslation()
  const [attachment, setAttachment] = useState({})

  useEffect(() => {
    if (attachmentData.type) {
      setAttachment(attachmentData)
    } else {
      setAttachment({})
    }
  }, [attachmentData])

  useEffect(() => {
    if (attachment.blob) {
      const file = new File(
        [attachment.blob],
        attachment.name,
        { type: attachment.type },
      )
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      document.getElementById('formFile').files = dataTransfer.files
      setSelectedFile(file)
    }
  }, [attachment])

  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '7rem auto',
        }}
      >
        <div
          style={{
            padding: '5px 0',
          }}
        >
          <button
            onClick={onAttachFile}
            type="button"
            className="btn btn-primary waves-effect waves-light"
            style={{
              width: '100%',
            }}
            disabled={isLoading}
          >
            {t('emission.form.label17')}
          </button>
        </div>
        <div
          style={{
            padding: '5px 8px 5px',
            alignSelf: 'center',
          }}
        >
          {isLoading ? (
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <span className="text-muted">
              {selectedFile?.name}
            </span>
          )
          }
        </div>
        <div
          style={{
            padding: '5px 0',
          }}
        >
          {attachment?.url ? (
            <a
              className={`btn btn-info ${isLoading ? 'btn-soft-dark pe-none' : ''}`}
              style={{
                cursor: 'pointer',
                width: '100%',
              }}
              href={attachment.url}
              target="_blank"
              rel="noreferrer"
              download={attachment.name}
            >
              {t('dashboard.btnDownload')}
            </a>
          ) : (
            <p>{t('emission.noAttachment')}</p>
          )}
        </div>
      </div>
      <input
        onChange={onChangeFile}
        style={{ display: "none" }}
        className="form-control"
        type="file"
        id="formFile"
        accept="image/*,.pdf,.doc"
      />
    </>
  )
}

export default function ExternalWasteEmissionUpdate() {
  const { t, i18n } = useTranslation()
  const { id } = useParams()
  console.log('Received ID:', id);
  const account = useSelector((state) => state.account.value)
  const isParent = account?.is_parent === 1 ? true : false;
  const [companyList, setCompanyList] = useState([])
  const [selectedFile, setSelectedFile] = useState(null)
  const [locationList, setlocationList] = useState([])
  const [unitList, setUnitList] = useState([])
  const [selectedCompanyId, setSelectedCompanyId] = useState('')
  const [selectedLocationId, setSelectedLocationId] = useState('')
  const [selectedWasteType, setSelectedWasteType] = useState('')
  const [selectedUnitId, setSelectedUnitId] = useState('')
  const [selectedEmissionFactorId, setSelectedEmissionFactorId] = useState('')
  const [emissionFactorList, setEmissionFactorList] = useState([])
  const [recordAmount, setRecordAmount] = useState(0)
  const [asetName, setAsetName] = useState('')
  const [selectedDate, setSelectedDate] = useState('')
  const [dataOwner, setDataOwner] = useState('')
  const [dataSource, setDataSource] = useState('')
  const [verifiedBy, setVerifiedBy] = useState('')
  const [attachmentId, setAttachmentId] = useState('')

  const [isNotFound, setIsNotFound] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [redirectEmission, setRedirectEmission] = useState(false) // Tambahan baru

  const formatDateForSubmission = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    const getUnits = async () => {
      if (!selectedEmissionFactorId || selectedEmissionFactorId === 0) {
        setUnitList([])
        setSelectedUnitId('')
        return
      }

      try {
        const unitResponse = await axios({
          withCredentials: true,
          method: 'GET',
          headers: { 'content-type': 'application/json' },
          params: {
            emissionFactorId: selectedEmissionFactorId,
          },
          url: `${process.env.REACT_APP_BASE_SERVER}/api/v2/emission-factor-unit-lookup`
        })

        if (unitResponse.data.ok) {
          setUnitList(unitResponse.data.data)
          setSelectedUnitId('')
        }
      } catch (err) {
        console.log('Error fetching units:', err)
        setUnitList([])
      }
    }

    getUnits()
  }, [selectedEmissionFactorId])

  useEffect(() => {
    const getLocation = async () => {
      if (!selectedCompanyId || selectedCompanyId === 0) {
        setlocationList([])
        setSelectedLocationId('')
        return
      }

      try {
        const locationResponse = await axios({
          withCredentials: true,
          method: 'GET',
          headers: { 'content-type': 'application/json' },
          params: {
            companyId: selectedCompanyId,
          },
          url: `${process.env.REACT_APP_BASE_SERVER}/client-office-lookup`
        })
        if (locationResponse.data.ok) {
          setlocationList(locationResponse.data.data)
        }
      }
      catch (err) {
        console.log(err)
        setlocationList([])
      }
    }
    getLocation()
  }, [selectedCompanyId])

  useEffect(() => {
    const getInitialData = async () => {
      try {
        setIsLoading(true)

        const responseRecord = await axios({
          withCredentials: true,
          method: 'GET',
          headers: { 'content-type': 'application/json' },
          params: {
            uuid: id,
          },
          url: `${process.env.REACT_APP_BASE_SERVER}/external-waste-emission-record-lookup`
        })

        const responCompanyList = await axios({
          withCredentials: true,
          method: 'POST',
          url: `${process.env.REACT_APP_BASE_SERVER}/client-company`
        })

        if (responCompanyList.data.ok) {
          setCompanyList(responCompanyList.data.data)
        }

        const emissionFactorList= await axios({
          withCredentials: true,
          method: 'GET',
          params: {
             scope : 3,
             category : 5
          },
          headers: { 'content-type': 'application/json' },
          url: `${process.env.REACT_APP_BASE_SERVER}/api/v2/emission-factor-lookup`
        })

        if (emissionFactorList.data.ok) {
          setEmissionFactorList(emissionFactorList.data.data)
        }

        if (responseRecord.data.ok) {
          const record = responseRecord.data.data
          setSelectedCompanyId(record.company.id || 0)
          setSelectedLocationId(record.location.id || 0)
          setSelectedEmissionFactorId(record.emissionFactor.id || 0)
          setSelectedUnitId(record.unit.id || 0)
          setRecordAmount(record.total || 0)
          setAsetName(record.asset || '')
          setAttachmentId(record.attachment_id || '')

          if (record.date) {
            const recordDate = new Date(record.date)
            setSelectedDate(recordDate)
          }

          setSelectedWasteType(record.wasteType || '')
          setDataOwner(record.owner || '')
          setDataSource(record.source || '')
          setVerifiedBy(record.verifiedBy || '')

        } else {
          throw new Error(responseRecord.data.message || 'Failed to load data')
        }
      } catch (error) {
        console.error('Error in getInitialData:', error)

        if (error?.response?.status === 401) {
          window.location.href = '/login'
          return
        }

        if (error?.response?.data?.status === 404) {
          setIsNotFound(true)
        } else {
          let message = 'An error occurred while loading data'
          if (typeof error.response?.data?.message === 'string') {
            message = error.response.data.message
          } else if (error.message) {
            message = error.message
          }

          Swal.fire({
            icon: 'error',
            title: 'Error',
            html: `<p style="font-size:0.75rem">${message}</p>`,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
          })
        }
      } finally {
        setIsLoading(false)
      }
    }

    if (id) {
      getInitialData()
    }
  }, [id])

  const onSaveRecord = async (e) => {
    e.preventDefault()

    if (!selectedCompanyId || selectedCompanyId === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select a company'
      })
      return
    }

    if (!selectedLocationId || selectedLocationId === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select a location'
      })
      return
    }

    if (!selectedEmissionFactorId || selectedEmissionFactorId === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select an emission factor'
      })
      return
    }
    if (!selectedDate) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select a date'
      })
      return
    }

    if (!recordAmount || recordAmount <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter a valid amount'
      })
      return
    }

    try {
      setIsSaving(true)
      const updateData = {
        date: formatDateForSubmission(selectedDate),
        total: recordAmount,
        asset: asetName,
        company: {
          id: selectedCompanyId
        },
        location: {
          id: selectedLocationId
        },
        emissionFactor: {
          id: selectedEmissionFactorId
        },
        unit: {
          id: selectedUnitId
        },
        owner: dataOwner,
        wasteType: selectedWasteType,
        source: dataSource,
        verifiedBy: verifiedBy
      }

      let requestData
      let contentType

      if (selectedFile) {
        requestData = new FormData()
        requestData.append('uuid', id)
        requestData.append('record_date', formatDateForSubmission(selectedDate))
        requestData.append('record_amount', updateData.total)
        requestData.append('record_assets', updateData.asset)
        requestData.append('company_name', updateData.company.id)
        requestData.append('office_name', updateData.location.id)
        requestData.append('emission_name', updateData.emissionFactor.id)
        requestData.append('unit_label', updateData.unit.id)
        requestData.append('data_owner', updateData.owner)
        requestData.append('waste_type', updateData.wasteType)
        requestData.append('data_source', updateData.source)
        requestData.append('verified_by', updateData.verifiedBy)
        requestData.append('attachment', selectedFile)
        contentType = 'multipart/form-data'
      } else {
        requestData = {
          uuid: id,
          updateData: updateData
        }
        contentType = 'application/json'
      }

      const response = await axios({
        withCredentials: true,
        method: 'POST',
        headers: {
          'content-type': contentType
        },
        data: requestData,
        url: `${process.env.REACT_APP_BASE_SERVER}/update-external-waste-emission-record`
      })

      if (response.data.ok) {
        // Tambahan baru: SweetAlert dengan redirect
        Swal.fire({
          title: 'Success',
          html: '<p>Successfully updated emission record</p>',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
            setRedirectEmission(true)
          }
        })
      } else {
        throw new Error(response.data.message || 'Failed to update record')
      }
    } catch (error) {
      console.error('Error in onSaveRecord:', error)

      if (error?.response?.status === 401) {
        window.location.href = '/login'
        return
      }

      let message = 'An error occurred while updating the record'
      if (typeof error.response?.data?.message === 'string') {
        message = error.response.data.message
      } else if (error.message) {
        message = error.message
      }

      Swal.fire({
        title: 'Error',
        html: `<p>${message}</p>`,
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
        icon: 'error',
      })
    } finally {
      setIsSaving(false)
    }
  }

  const onAttachFile = async () => {
    document.getElementById('formFile').click()
  }

  const onChangeFile = async (e) => {
    const files = e.target.files
    setSelectedFile(files?.[0])
  }

  const onInputChange = (e) => {
    const { name, value } = e.target

    if (name === 'dataOwner') {
      setDataOwner(value)
    } else if (name === 'dataSource') {
      setDataSource(value)
    } else if (name === 'verifiedBy') {
      setVerifiedBy(value)
    } else if (name === 'company_name') {
      setSelectedCompanyId(value)
      setSelectedLocationId('')
    } else if (name === 'locationId') {
      setSelectedLocationId(value)
    } else if (name === 'wasteType') {
      setSelectedWasteType(value)
    } else if (name === 'emissionFactorId') {
      setSelectedEmissionFactorId(value)
      setSelectedUnitId('')
    } else if (name === 'unitId') {
      setSelectedUnitId(value)
    } else if (name === 'asetName') {
      setAsetName(value)
    }
  }

  const onInputNumericFormatChange = (values, sourceInfo) => {
    if (sourceInfo?.event?.target?.name && values) {
      if (sourceInfo.event.target.name === 'recordTotal') {
        setRecordAmount(values.value)
      }
    }
  }

  // Tambahan baru: Redirect untuk parent
  if (isParent) {
    return <Navigate to={ROUTE_PATHS.scope3category29} />
  }

  // Tambahan baru: Redirect setelah update berhasil
  if (redirectEmission) {
    return <Navigate to={ROUTE_PATHS.scope3category5} />
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">
                {t("menu.scope3Category5Title")}
              </h4>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">
                  {t('general.btnUpdate')} External Waste Emission Record
                </h4>
              </div>

              {isLoading ? (
                <div className="card-body">
                  <LoadingCard />
                </div>
              ) : (
                <>
                  {isNotFound ? (
                    <div className="card-body">
                      <NotFound />
                    </div>
                  ) : (
                    <div className="card-body">
                        <div className="row">
                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="company_name" className="form-label">
                                {t('emission.form.label1')} <span className="text-danger">*</span>
                              </label>
                              <select
                                id="company_name"
                                name="company_name"
                                onChange={onInputChange}
                                value={selectedCompanyId}
                                className="form-select mb-3"
                                required
                              >
                                <option value={0}>
                                  {t('emission.form.select')}
                                </option>
                                {companyList.map(item => (
                                  <option
                                    key={item.company_id}
                                    value={item.company_id}
                                  >
                                    {item.company_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="locationId" className="form-label">
                                {t('emission.table.label2')} <span className="text-danger">*</span>
                              </label>
                              <select
                                id="locationId"
                                name="locationId"
                                onChange={onInputChange}
                                value={selectedLocationId}
                                className="form-select"
                                required
                              >
                                <option value={0}>
                                  {t('emission.form.select')}
                                </option>
                                {locationList.map(item => (
                                  <option
                                    key={item.office_id}
                                    value={item.office_id}
                                  >
                                    {`${item.office_name}${item.office_address ? ` (${item.office_address})` : ''}`}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="recordDate" className="form-label">
                                {t('emission.form.date')} <span className="text-danger">*</span>
                              </label>
                              <div>
                                <DatePicker
                                  id="recordDate"
                                  name="recordDate"
                                  selected={selectedDate}
                                  onChange={(date) => setSelectedDate(date)}
                                  dateFormat="dd MMMM yyyy"
                                  className="form-control"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="dataSource" className="form-label">
                                {t('emission.form.DataSource')} <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="dataSource"
                                name="dataSource"
                                onChange={onInputChange}
                                value={dataSource}
                                className="form-control"
                                placeholder="Enter data source"
                                required
                              />
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="dataOwner" className="form-label">
                                {t('emission.form.dataOwner')} <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="dataOwner"
                                name="dataOwner"
                                onChange={onInputChange}
                                value={dataOwner}
                                className="form-control"
                                placeholder="Enter data owner"
                                required
                              />
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="verifiedBy" className="form-label">
                                {t('emission.form.verifiedBy')} <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="verifiedBy"
                                name="verifiedBy"
                                onChange={onInputChange}
                                value={verifiedBy}
                                className="form-control"
                                placeholder="Enter verifier"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="asetName" className="form-label">
                                {t('emission.form.label7')} <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="asetName"
                                name="asetName"
                                onChange={onInputChange}
                                value={asetName}
                                className="form-control"
                                required
                                placeholder="Enter asset name"
                              />
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="wasteType" className="form-label">
                                {t('menu.label57')} <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="wasteType"
                                name="wasteType"
                                onChange={onInputChange}
                                value={selectedWasteType}
                                className="form-control"
                                required
                                placeholder="Enter waste type"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="emissionFactorId" className="form-label">
                                {t('onboard.summaryEFDetail')} <span className="text-danger">*</span>
                              </label>
                              <select
                                id="emissionFactorId"
                                name="emissionFactorId"
                                onChange={onInputChange}
                                value={selectedEmissionFactorId}
                                className="form-select"
                                required
                              >
                                <option value={0}>
                                  {t('emission.form.select')}
                                </option>
                                {emissionFactorList.map(item => (
                                  <option
                                    key={item.emission_factor_id}
                                    value={item.emission_factor_id}
                                  >
                                    {item.emission_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="unitId" className="form-label">
                                {t('setting.revenueAndProduction.unit')} <span className="text-danger">*</span>
                              </label>
                              <select
                                id="unitId"
                                name="unitId"
                                onChange={onInputChange}
                                value={selectedUnitId}
                                className="form-select"
                                required
                              >
                                {unitList.map(item => (
                                  <option
                                    key={item.unit_id}
                                    value={item.unit_id}
                                  >
                                    {item.unit_label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="mb-3">
                              <label htmlFor="recordTotal" className="form-label">
                                {t('emission.form.amountSpent')} <span className="text-danger">*</span>
                              </label>
                              <NumericFormat
                                id="recordTotal"
                                name="recordTotal"
                                className="form-control"
                                value={recordAmount}
                                onValueChange={onInputNumericFormatChange}
                                decimalSeparator={i18n.language === 'id' ? ',' : '.'}
                                thousandSeparator={i18n.language === 'id' ? '.' : ','}
                                placeholder="Enter amount"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label htmlFor="formFile" className="form-label">
                                {t('emission.form.label15')}
                              </label>
                              <p className="text-muted">
                                {t('emission.form.label16')}
                              </p>
                              <div className="col-md-6">
                                <Attachment id={attachmentId}>
                                  {({ attachment, isLoading: attachmentLoading }) => {
                                    return <AttachmentChildren
                                      setSelectedFile={setSelectedFile}
                                      onAttachFile={onAttachFile}
                                      selectedFile={selectedFile}
                                      onChangeFile={onChangeFile}
                                      attachmentData={attachment}
                                      isLoading={attachmentLoading}
                                    />
                                  }}
                                </Attachment>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <div className="text-end">
                              <button
                                onClick={onSaveRecord}
                                type="button"
                                className="btn btn-primary"
                                disabled={isSaving || isLoading}
                              >
                                {isSaving ? 'Saving...' : t('general.btnSave')}
                              </button>
                            </div>
                          </div>
                        </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
